<template>
  <div>
    <ListDialog ref="updateDeliveryDateDialog" title="納期更新" :captions="[]" :widths="[]" :showAdd="false" :showRemove="false" :exec="submitUpdateDeliveryDate" >
      <template slot="header">
        <Calendar title="回答納期" :value.sync="uddAnswerDeliveryDate" :deletable="true" tooltip="回答納期に変更があった場合変更された日付を入力します。ブランクの場合は現在の値が維持されます。"/>
        <Calendar :title="salesPurchaseFlag==1?'出荷予定日':'入荷予定日'" :value.sync="uddScheduledDeliveryDate" :deletable="true" :tooltip="salesPurchaseFlag==1?'出荷予定日に変更があった場合変更された日付を入力します。ブランクの場合は現在の値が維持されます。':'入荷予定日に変更があった場合変更された日付を入力します。ブランクの場合は現在の値が維持されます。'"/>
      </template>
    </ListDialog>
  </div>
</template>


<script lang="ts">
import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';

@Component
export default class ReturnDelivery extends Vue {
  @Prop() public checkedOrderItems:Array<Common.OrderItem>; 
  @Prop() public parentMainList:Components.ListView;
  @Prop() public gridVoucherItem:Components.GrdVoucherItem;

  public uddAnswerDeliveryDate:Date = null;
  public uddScheduledDeliveryDate:Date = null;
  public salesPurchaseFlag :Common.SalesPurchaseFlags = null;
  
  // 納期更新ダイアログの表示
  public mounted() {
    // ダイアログ表示前バリデーション
    if(this.checkedOrderItems.length == 0){
      this.$api.modal.show('', '対象の明細を選択して下さい。', true, null);
      return;
    }
    if(this.checkedOrderItems.filter(item => item.order.isSubscription).length > 0){
      this.$api.modal.show('', 'サブスクリプション明細の納期更新は行えません。', true, null);
      return;
    }    
    // プロパティの初期化
    this.uddAnswerDeliveryDate = null;
    this.uddScheduledDeliveryDate = null;
    this.salesPurchaseFlag = this.checkedOrderItems[0].salesPurchaseFlag;

    // ダイアログを表示
    (this.$refs.updateDeliveryDateDialog as Components.ListDialog).showDialog();
  }

  // 納期更新の実行
  public async submitUpdateDeliveryDate() {
    // クエリの設定
    var query = new Common.UpdateDeliveryDateQuery();
    query.orderItems = this.checkedOrderItems;
    query.answerDeliveryDate = this.uddAnswerDeliveryDate;
    query.scheduledDeliveryDate = this.uddScheduledDeliveryDate;

    // 納期更新の実行
    await this.$api.execute(query).then(res => {
      // 画面更新
      if(this.parentMainList) this.parentMainList.reloadSelected()
      if(this.gridVoucherItem) this.gridVoucherItem.onVoucherNoChanged();
    });
  }
}
</script>